import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ResumePage = lazy(() => import('../pages/resume/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const GallerySubpage = lazy(() => import('../pages/gallery/subpage'));
const VenturesSubpage = lazy(() => import('../pages/gallery/ventures-subpage'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/resume',
    element: <ResumePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/gallery/ventures',
    element: <VenturesSubpage />,
  },
  {
    path: '/gallery/ventures/:category',
    element: <GallerySubpage />,
  },
  {
    path: '/gallery/:category',
    element: <GallerySubpage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;